<script>
  import { onMount } from "svelte";
  import { link } from "svelte-spa-router";
  import * as ls from "local-storage";
  import config from "../stores/config";

  let hash = window.location.hash.split("?")[0].toLowerCase();

  onMount(() => {});

  const handleLogout = () => {
    ls.remove("jwt");
    window.location = "/#/login";
  };
</script>

{#if $config?.currentUser}
  <div
    id="header"
    class="side-bar fixed top-0 left-0 z-50 h-screen overflow-auto bg-gray-800 text-gray-300 shadow-2xl"
  >
    <div
      class="pl-5 flex items-center uppercase font-bold shadow-sm bg-green-500 py-3 pr-5"
    >
      <img src="./favicon-rect.png" class="w-full" alt="" />
    </div>
    <ul class="mt-2">
      {#if $config?.currentUser?.department?.toLowerCase() == "management"}
        <a
          class="px-5 side-link flex items-center py-3"
          class:side-link-active={hash.startsWith("#/suppliers") ||
            hash.includes("addsupplier")}
          use:link
          href="/suppliers"
        >
          <i class="text-base text-green-600 fas fa-truck inline-block w-10" />
          Suppliers
        </a>
        <a
          class:side-link-active={hash === "#home" ||
            hash === "" ||
            hash.startsWith("#/products") ||
            hash.includes("addproduct")}
          class="px-5 side-link flex items-center py-3"
          href="#home"
        >
          <i
            class="text-base text-green-600 fas fa-warehouse inline-block w-10"
          />
          Stock Database
        </a>
        <a
          class="px-5 side-link flex items-center py-3"
          class:side-link-active={hash.startsWith("#/fstyles") ||
            hash.includes("addfstyle")}
          use:link
          href="/fstyles"
        >
          <i class="text-base text-green-600 fas fa-tshirt inline-block w-10" />
          Styles Stock
        </a>

        <a
          class="px-5 side-link flex items-center py-3"
          class:side-link-active={hash.startsWith("#/cmts") ||
            hash.includes("addcmt")}
          use:link
          href="/cmts"
        >
          <i
            class="text-base text-green-600 fas fa-users-cog inline-block w-10"
          />
          CMTs
        </a>

        <a
          class="px-5 side-link flex items-center py-3"
          class:side-link-active={hash.startsWith("#/customers") ||
            hash.includes("addcustomer")}
          use:link
          href="/customers"
        >
          <i class="text-base text-green-600 fas fa-users inline-block w-10" />
          Customers
        </a>

        <a
          class="px-5 side-link flex items-center py-3"
          class:side-link-active={hash.startsWith("#/reports") ||
            hash.includes("reports")}
          use:link
          href="/reports"
        >
          <i class="text-base text-green-600 fas fa-book inline-block w-10" />
          Reports
        </a>
      {/if}
      <a
        class="px-5 side-link flex items-center py-3"
        class:side-link-active={hash.startsWith("#/orders") ||
          hash.includes("addorder") ||
          hash.startsWith("#/styles")}
        use:link
        href="/orders"
      >
        <i
          class="text-base text-green-600 fas fa-shopping-basket inline-block w-10"
        />
        Orders
      </a>
      {#if $config?.currentUser?.department?.toLowerCase() == "management"}
        <a
          class="px-5 side-link flex items-center py-3"
          class:side-link-active={hash === "#/administrators"}
          use:link
          href="/administrators"
        >
          <i
            class="text-base text-green-600 fas fa-user-cog inline-block w-10"
          />
          Administrators
        </a>
      {/if}
      <a
        class="px-5 side-link flex items-center py-3"
        class:side-link-active={hash === "#/profile"}
        use:link
        href="/profile"
      >
        <i
          class="text-base text-green-600 fas fa-user-circle inline-block w-10"
        />
        Your Profile
      </a>
      <div
        class="px-5 side-link flex items-center py-3 cursor-pointer"
        on:click={handleLogout}
      >
        <i
          class="text-base text-green-600 fas fa-power-off inline-block w-10"
        />
        Logout
      </div>
    </ul>
  </div>
{/if}

<style>
  .side-link:hover {
    transition: all 250ms;
    background-color: rgba(16, 185, 129, 0.03);
    color: rgba(16, 185, 129, 0.75);
  }
</style>
